import {
    FETCH_CHECKOUT_REQUEST,
    FETCH_CHECKOUT_SUCCESS,
    FETCH_CHECKOUT_ERROR,
    HIDE_CHECKOUT_LOADER,
    SHOW_CHECKOUT_LOADER,
    ADD_CHECKOUT_REQUEST,
    ADD_CHECKOUT_SUCCESS,
    ADD_CHECKOUT_ERROR,
} from './checkout.constants';

export const fetchCheckoutDetailsRequest = payload => ({
    type: FETCH_CHECKOUT_REQUEST,
    payload,
});

export const fetchCheckoutDetailsSuccess = payload => ({
    type: FETCH_CHECKOUT_SUCCESS,
    payload,
});

export const fetchCheckoutDetailsError = payload => ({
    type: FETCH_CHECKOUT_ERROR,
    payload,
});
export const addCheckoutDetailsRequest = payload => ({
    type: ADD_CHECKOUT_REQUEST,
    payload,
});

export const addCheckoutDetailsSuccess = payload => ({
    type: ADD_CHECKOUT_SUCCESS,
    payload,
});

export const addCheckoutDetailsError = payload => ({
    type: ADD_CHECKOUT_ERROR,
    payload,
});

export const showLoader = () => ({ type: SHOW_CHECKOUT_LOADER });

export const hideLoader = () => ({ type: HIDE_CHECKOUT_LOADER });
